import React from "react";
import upstander1 from "../../../images/upstander1.jpg";
import upstander2 from "../../../images/upstander2.jpg";
import upstander3 from "../../../images/upstander3.jpg";
import upstander4 from "../../../images/upstander4.jpg";
import upstander5 from "../../../images/upstander5.jpg";
import EngagementCarouselPage from "../../ui/EngagementCarouselPage";

const Upstander = () => (
  <EngagementCarouselPage
    title="Upstander – The Power of One"
    paragraphs={[
      "The Hangout on 8th Feb highlighted through simple anecdotes the importance of 'standing up' and 'supporting' one another. Upstanders help make life meaningful for both themselves and others. We thank Mr. Scott Corse for guiding us in this Hangouts session.",
    ]}
    images={[upstander1, upstander2, upstander3, upstander4, upstander5]}
  />
);

export default Upstander;
